module.exports = __webpack_public_path__ + "static/media/consultationAirportInfrastructure.a52bf47c.jpg";